import { render, staticRenderFns } from "./addContract.vue?vue&type=template&id=5b82413e&scoped=true&"
import script from "./addContract.vue?vue&type=script&lang=js&"
export * from "./addContract.vue?vue&type=script&lang=js&"
import style0 from "./addContract.vue?vue&type=style&index=0&id=5b82413e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b82413e",
  null
  
)

export default component.exports